import s from './DetailedBookkeepingTable.module.css'

export const Profit = ({ profit }) => (
  <div className={s.profit} id='bookkeeping_profit'>
    Profit: {(profit * 1).toFixed(2)}
  </div>
)
